import React, { useState } from 'react';

import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Typography, IconButton, Box, Stack } from '@mui/material';

import { Group } from '../types/groups';
import GroupAccordion from './GroupCard/GroupAccordion';
import PaginationComponent from 'components/Pagination/Pagination';

interface GroupListProps {
  groups: Group[];
  searchTerm: string;
  onUpdate: () => void;
}

const ITEMS_PER_PAGE = 5;

export const GroupList: React.FC<GroupListProps> = ({ groups, searchTerm, onUpdate }) => {
  const [isAscending, setIsAscending] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  const handleSortToggle = () => {
    setIsAscending(!isAscending);
  };

  const filteredAndSortedGroups = groups
    .filter(group => group.name.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => (isAscending ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name)));

  const totalPages = Math.ceil(filteredAndSortedGroups.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentGroups = filteredAndSortedGroups.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <Stack direction="column" justifyContent="space-between" height="100%">
      <Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            padding: '0 8px',
            backgroundColor: 'background.secondary',
            color: 'text.primary',
            borderRadius: '4px',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flex: '0.33',
              bgcolor: 'background.secondary',
            }}
          >
            <Typography variant="caption">Nome</Typography>
            <IconButton onClick={handleSortToggle} size="small">
              {isAscending ? (
                <ArrowUpwardIcon fontSize="small" />
              ) : (
                <ArrowDownwardIcon fontSize="small" />
              )}
            </IconButton>
          </Box>
          <Typography variant="caption" sx={{ flex: '0.33', textAlign: 'center' }}>
            Usuários ativos
          </Typography>
          <Typography
            variant="caption"
            sx={{ flex: '0.34', textAlign: 'right', marginRight: '3.5rem' }}
          >
            Ações
          </Typography>
        </Box>
        <Box sx={{ marginTop: '0.5rem' }}>
          {currentGroups.map(group => (
            <GroupAccordion key={group.uuid} group={group} onUpdate={onUpdate} />
          ))}
        </Box>
      </Box>
      <Box display="flex" justifyContent="center" alignItems="center" mt={2} mb={2}>
        <PaginationComponent
          totalPages={totalPages}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          siblingCount={1}
          boundaryCount={1}
          color="custom"
          customColor={'background.secondary'}
        />
      </Box>
    </Stack>
  );
};

export default GroupList;
